import { type Dispatch, type SetStateAction, createContext, useContext } from "react";

/**
 * Context + hook del sidebar. Separado del Provider para que
 * `sidebar-context.tsx` solo exporte componentes y así satisfaga la
 * regla `react-refresh/only-export-components` (Fast Refresh friendly).
 */
export interface SidebarContextValue {
  collapsed: boolean;
  setCollapsed: Dispatch<SetStateAction<boolean>>;
  toggleCollapsed: () => void;

  mobileOpen: boolean;
  setMobileOpen: Dispatch<SetStateAction<boolean>>;
  openMobile: () => void;
  closeMobile: () => void;
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export function useSidebar(): SidebarContextValue {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error("useSidebar must be used inside <SidebarProvider>");
  return ctx;
}
